// src/utils/deviceUtils.js — 기기 종류 판별
// 모바일 여부는 UA 힌트 → UA 문자열 → 터치 포인트 순으로 판단한다.
// iPadOS 사파리는 UA를 Mac으로 보내므로 터치 포인트로 보정한다.
export const isMobileDevice = () => {
    if (typeof navigator === 'undefined') return false;

    // Chromium 계열: 표준화된 UA 힌트가 가장 정확하다
    if (navigator.userAgentData && typeof navigator.userAgentData.mobile === 'boolean') {
        return navigator.userAgentData.mobile;
    }

    const ua = navigator.userAgent || '';
    if (/Android|iPhone|iPad|iPod|Mobile/i.test(ua)) return true;

    // iPadOS 13+ 사파리 "데스크톱 사이트" 모드 — UA는 Macintosh, 터치는 있음
    return /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1;
};
